import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Terms from "../components/Terms";
import AuthHeader from "../components/AuthHeader";
import { useAnalysis } from "./useAnalysis";
import AnalysisPageLayout from "./components/AnalysisPageLayout";

const AnalysisPageInner = ({ analysisId }: { analysisId: string }) => {
  const { reportData, analysisInfo, loadStatus, errorMsg } = useAnalysis(analysisId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [analysisId]);

  return (
    <AnalysisPageLayout
      analysisId={analysisId}
      reportData={reportData}
      analysisInfo={analysisInfo}
      loadStatus={loadStatus}
      errorMsg={errorMsg}
    />
  );
};

const AnalysisPage = () => {
  const { analysis_id: analysisId } = useParams<{ analysis_id: string }>();

  return (
    <div className="app">
      <Terms />
      <div style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
        <AuthHeader layout="fixed" />
      </div>
      {analysisId && <AnalysisPageInner analysisId={analysisId} />}
    </div>
  );
};

export default AnalysisPage;
